import { AppProviders } from "@/app/providers/AppProviders";
import type { QueryClient } from "@tanstack/react-query";

/** Composes application-wide providers without introducing feature behavior. */
export function App({ queryClient }: { queryClient: QueryClient }) {
  return <AppProviders queryClient={queryClient} />;
}
